import { useEffect, useState } from 'react';
import { Column, GridApi } from 'ag-grid-community';

import { useInstance } from 'app/libs/use-instance';

import { FilterModels } from '../filters';

type UseFilterModelSubscribeParams = {
  gridApi: GridApi;
  column: Column;
};
export const useFilterModel = ({
  gridApi,
  column,
}: UseFilterModelSubscribeParams) => {
  const filterInst = useInstance(() => gridApi.getFilterInstance(column));
  const [model, setModel] = useState(() => filterInst?.getModel());

  const setFilterModel = (model: FilterModels | null) => {
    filterInst?.setModel(model);
    gridApi.onFilterChanged();
  };

  useEffect(() => {
    const handleModelSubscription = () => {
      const model = filterInst?.getModel();
      setModel(model);
    };

    gridApi.addEventListener('filterChanged', handleModelSubscription);

    return () => {
      gridApi.removeEventListener('filterChanged', handleModelSubscription);
    };
  }, []);

  return [model, setFilterModel] as const;
};
